export default "__VITE_ASSET__DJevLzLo__"